import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { X } from 'lucide-react';
export const Problem: React.FC = () => {
  const problems = ['Se saturan con videos de YouTube que dan consejos genéricos que no aplican a su perfil.', 'Llegan a la cita con un guion mental que suena a súplica, no a certeza.', 'Hablan de más y activan las sospechas del oficial sin darse cuenta.', 'Gastan $200 en asesores que les dicen lo mismo que a todo el mundo.'];
  return <SectionWrapper data-id="element-137">
      <div className="bg-dark-red rounded-2xl p-8 md:p-12 border border-red-900/30 shadow-xl" data-id="element-138">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center" data-id="element-139">
          Por qué la mayoría pierde su Visa antes de abrir la boca.
        </h2>

        <ul className="space-y-6" data-id="element-140">
          {problems.map((problem, index) => <li key={index} className="flex items-start gap-4" data-id="element-141">
              <div className="mt-1 bg-red-950/50 p-1 rounded-full shrink-0" data-id="element-142">
                <X className="text-red-500" size={24} strokeWidth={3} data-id="element-143" />
              </div>
              <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-144">
                {problem}
              </p>
            </li>)}
        </ul>
      </div>
    </SectionWrapper>;
};